// extracted by mini-css-extract-plugin
export default {"root":"ngwfjBwLaP","header":"jwT6yzlMNV","content":"EyM4YFXJRG","message":"bNlJT25uBa","info":"j58QREWM6m","image":"SqflRoxlLV","statistics":"IIyDeAWopM"};